import type { OrderItem } from '@octave/contracts';

interface SimItemMetadataProps {
  item: OrderItem;
}

export function SimItemMetadata({ item }: SimItemMetadataProps) {
  const metadata = item.metadata;
  if (metadata.type !== 'SIM') return null;

  return (
    <div className="mt-2 space-y-2">
      <div className="text-xs text-gray-500">
        <div>
          Type de SIM: {metadata.simType === 'physique' ? 'Physique' : 'eSIM'}
        </div>
        {metadata.physiqueOption === 'order' && <div>Carte SIM commandée</div>}
        {metadata.physiqueOption === 'stock' && <div>Carte SIM en stock</div>}
      </div>

      {/* Site Information — snapshot pris à l'ajout au panier */}
      {metadata.siteName && (
        <div className="text-xs text-gray-500">
          <div>Centre de facturation: {metadata.siteName}</div>
        </div>
      )}

      {/* SIM Number Badge */}
      {metadata.simNumber && (
        <div className="mt-2">
          <span className="text-xs bg-orange-50 text-orange-700 px-2 py-1 rounded-md border border-orange-200">
            {metadata.simNumber}
          </span>
        </div>
      )}
    </div>
  );
}
